var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.445312 1.55556C0.445312 0.696446 1.14176 0 2.00087 0C2.85998 0 3.55642 0.696446 3.55642 1.55556C3.55642 2.41467 2.85998 3.11111 2.00087 3.11111C1.14176 3.11111 0.445312 2.41467 0.445312 1.55556ZM0.445312 7C0.445312 6.14089 1.14176 5.44444 2.00087 5.44444C2.85998 5.44444 3.55642 6.14089 3.55642 7C3.55642 7.85911 2.85998 8.55556 2.00087 8.55556C1.14176 8.55556 0.445312 7.85911 0.445312 7ZM2.00087 10.8889C1.14176 10.8889 0.445312 11.5853 0.445312 12.4444C0.445312 13.3036 1.14176 14 2.00087 14C2.85998 14 3.55642 13.3036 3.55642 12.4444C3.55642 11.5853 2.85998 10.8889 2.00087 10.8889Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.7f98497e9522d83530ec44bbce2a8524.svg";
export { ForwardRef as ReactComponent };